export default __webpack_public_path__ + "static/media/loading.547112a7.gif";